module.exports = __webpack_public_path__ + "img/icoon_groepsgesprek_small.38bf00f7.svg";